import "./Home.module.css";
import StudioCommandHeader from "@/reusable_sections/Header";
import LetYourPropertyWithConfidence from "./sections/LetYourPropertyWithConfidence";
import DiscoverYourSanctuary from "./sections/DiscoverYourSanctuary";
import PremierRentalGallery from "./sections/PremierRentalGallery";
import TheLandlordEdge from "./sections/TheLandlordEdge";
import SuccessInNumbers from "./sections/SuccessInNumbers";
import GetYourFreeValuation from "./sections/GetYourFreeValuation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <StudioCommandHeader />
      <LetYourPropertyWithConfidence />
      <DiscoverYourSanctuary />
      <PremierRentalGallery />
      <TheLandlordEdge />
      <SuccessInNumbers />
      <GetYourFreeValuation />
      <Footer />
    </div>;
}